import axios from '@/api/config';

const projectPhaseItem = {
  getProjectPhaseItemById(data) {
    return axios.get(`${process.env.BASE_URL}/projectPhaseItem/getProjectPhaseItemById/` + data, {});
  },
  getProjectPhaseItemDetail(data) {
    return axios.get(`${process.env.BASE_URL}/projectPhaseItem/getProjectPhaseItemDetail`, {params: data});
  },
  getProjectPhaseItem(data) {
    return axios.get(`${process.env.BASE_URL}/projectPhaseItem/getProjectPhaseItem`, {params: data});
  },
  getProjectPhaseItemList(data) {
    return axios.get(`${process.env.BASE_URL}/projectPhaseItem/getProjectPhaseItemList`, {params: data});
  },
  getProjectPhaseItemTree(data) {
    return axios.get(`${process.env.BASE_URL}/projectPhaseItem/getProjectPhaseItemTree`, {params: data});
  },
  pageList(data) {
    return axios.post(`${process.env.BASE_URL}/projectPhaseItem/pageList`, data);
  },
  addProjectPhaseItem(data) {
    return axios.post(`${process.env.BASE_URL}/projectPhaseItem/addProjectPhaseItem`, data);
  },
  updateProjectPhaseItem(data) {
    return axios.put(`${process.env.BASE_URL}/projectPhaseItem/updateProjectPhaseItem`, data);
  },
  deleteProjectPhaseItem(data) {
    return axios.delete(`${process.env.BASE_URL}/projectPhaseItem/deleteProjectPhaseItem`,  {data: data});
  },
  exportExcel(data) {
    return axios.get(`${process.env.BASE_URL}/projectPhaseItem/exportExcel`, {params: data});
  },
  importData(data) {
    return axios.post(`${process.env.BASE_URL}/projectPhaseItem/importData`, data);
  },
  active(data) {
    return axios.post(`${process.env.BASE_URL}/projectPhaseItem/active`, data);
  },
  updateSn(data) {
    return axios.post(`${process.env.BASE_URL}/projectPhaseItem/updateSn`, data);
  },
}

export default projectPhaseItem;



// WEBPACK FOOTER //
// ./src/api/projectPhaseItem.js